import http from '../http';
import {api} from '../api';
import {
  GetSummariesByDateBody,
  SummariesByDateData,
  SummaryDetailsItemType,
} from '../../interfaces/api/summaries';
import {store} from '../../redux/store';
import {HttpResponse} from '../../interfaces/api/http';

export const summaries = {
  getById: (id: number): Promise<HttpResponse<SummaryDetailsItemType>> =>
    new Promise((resolve, reject) => {
      let url = `${api.summaries.getById}${id}`;
      http
        .get<SummaryDetailsItemType>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),

  getByDate: ({
    tabId,
    dateFrom,
    dateTo,
    page,
    filters,
  }: GetSummariesByDateBody): Promise<HttpResponse<SummariesByDateData>> =>
    new Promise((resolve, reject) => {
      const {specialty_id} = store.getState().auth?.currentUser || {};
      const params = new URLSearchParams();
      if (!tabId || !specialty_id) {
        throw new Error('tab id and subspecialty id are required');
      }
      params.append('tab_id', tabId.toString());
      params.append('specialty_id', specialty_id.toString());
      Object.keys(filters || {}).forEach(key => {
        if (
          filters[key] &&
          (key === 'specialty_id' ||
            key === 'type_of_study_id' ||
            key === 'resource_id')
        ) {
          params.append(key, String(filters[key]));
        }
      });
      params.append('dateFrom', dateFrom.toString());
      if (dateTo) {
        params.append('dateTo', dateTo.toString());
      }

      if (page) {
        params.append('page', page.toString());
        params.append('pageSize', '10');
      }
      const url = `${api.summaries.getByDateRange}?${params.toString()}`;
      http
        .get<SummariesByDateData>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
};
